import { render, staticRenderFns } from "./DanhSachApp.vue?vue&type=template&id=1ce5b39a&"
import script from "./DanhSachApp.vue?vue&type=script&lang=js&"
export * from "./DanhSachApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports